import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "revico-community-talk-reply-details-response",
        onClick: $setup.onClick
      }, _toDisplayString($setup.wordSettings.reviewReplyLinkText), 1 /* TEXT */))
    : _createCommentVNode("v-if", true)
}